var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sadadream-wrapper"},[_vm._m(0),(_vm.instituteId)?_c('div',{staticClass:"wrapper"},[_c('MyList'),_c('OtherList')],1):_vm._e()])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"banner"},[_c('div',{staticClass:"wrapper"})])
}]

export { render, staticRenderFns }